import { SvgIcon, type SvgIconProps } from '@mui/material'

export function PatientIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 16 16'>
      <path d='M8 10C10.67 10 16 11.34 16 14V16H0V14C0 11.34 5.33 10 8 10ZM8 0C10.21 0 12 1.79 12 4C12 6.21 10.21 8 8 8C5.79 8 4 6.21 4 4C4 1.79 5.79 0 8 0Z' />
    </SvgIcon>
  )
}

export function MedicationRequestIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 14 14'>
      <path d='M7.9502 0.878657C9.12177 -0.292916 11.0213 -0.292916 12.1928 0.878657C13.3644 2.05023 13.3644 3.94973 12.1928 5.1213L5.12177 12.1924C3.9502 13.3639 2.05071 13.3639 0.879133 12.1924C-0.29244 11.0208 -0.29244 9.1213 0.879133 7.94972L7.9502 0.878657ZM5.35794 4.41419L8.65731 7.71356L11.7212 4.64966C12.6324 3.73844 12.6324 2.26151 11.7212 1.35029C10.81 0.439068 9.33306 0.439069 8.42184 1.35029L5.35794 4.41419Z' />
    </SvgIcon>
  )
}

export function TaskIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 16 16'>
      <path d='M14.2227 0C15.2001 0.000236607 15.9998 0.799908 16 1.77734V14.2227C15.9998 15.2001 15.2001 15.9998 14.2227 16H1.77734C0.799908 15.9998 0.000236607 15.2001 0 14.2227V1.77734C0.000236672 0.799908 0.799908 0.000236672 1.77734 0H14.2227ZM2.66699 13.333H7.11133V8.88867H2.66699V13.333ZM6.2207 12.4443H3.55371V9.77832H6.2207V12.4443ZM8.8877 12H13.332V10.2217H8.8877V12ZM2.66699 7.11133H7.11133V2.66699H2.66699V7.11133ZM6.2207 6.22168H3.55371V3.55566H6.2207V6.22168ZM8.8877 5.77734H13.332V4H8.8877V5.77734Z' />
    </SvgIcon>
  )
}

export function CommunicationsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 16 16'>
      <path d='M14.3994 0C15.2793 0 15.9998 0.71979 16 1.59961V11.2002C15.9998 12.08 15.2793 12.7998 14.3994 12.7998H3.2002L0 16V1.59961C0.000195921 0.71991 0.71991 0.000195921 1.59961 0H14.3994ZM7.2002 8.7998V10.3994H8.7998V8.7998H7.2002ZM7.2002 7.2002H8.7998V2.40039H7.2002V7.2002Z' />
    </SvgIcon>
  )
}

export function CSNotesIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 14 18'>
      <path d='M8.64355 0L13.8301 5.18555V15.5586C13.8299 16.5092 13.0522 17.287 12.1016 17.2871H1.71973C0.769169 17.2869 0.000131657 16.5092 0 15.5586L0.00878906 1.72852C0.00878906 0.777779 0.77781 0.000133191 1.72852 0H8.64355ZM7.7793 6.0498H12.5332L7.7793 1.2959V6.0498Z' />
    </SvgIcon>
  )
}
